<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input style="width:100%" v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                <!-- <a-col :span="8">
                    <a-form-item label="类型" name="creditType">
                        <DictSelect
                            v-model:value="form.creditType"
                            :dict-name="financeDict.LOANTYPE"
                            placeholder="请选择"
                        />
                    </a-form-item>
                </a-col> -->
                <a-col :span="8">
                    <a-form-item label="申请企业" name="companyName">
                        <a-input style="width:100%" v-model:value="form.companyName" placeholder="请输入申请企业" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="联系人" name="contact">
                        <a-input style="width:100%" v-model:value="form.contact" placeholder="请输入联系人" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="联系电话" name="contactNumber">
                        <a-input style="width:100%" v-model:value="form.contactNumber" placeholder="请输入联系电话" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="申请贷款额度（万元）" name="loanAmount">
                        <a-input style="width:100%" v-model:value="form.loanAmount" placeholder="请输入申请贷款额度（万元）" />
                    </a-form-item>
                </a-col>
                <!-- <a-col :span="8">
                    <a-form-item label="授信金额" name="creditAmount">
                        <a-input style="width:100%" v-model:value="form.creditAmount" placeholder="请输入授信金额" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="贷款时间" name="loanTime">
                        <date-picker v-model:value="form.loanTime" show-time />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="授信时间" name="creditTime">
                        <date-picker v-model:value="form.creditTime" show-time />
                    </a-form-item>
                </a-col> -->

                <!-- <a-col :span="8">
                    <a-form-item label="服务类型" name="type">
                        <a-radio-group v-model:value="form.type">
                            <a-radio :value="0">线下</a-radio>
                            <a-radio :value="1">线上</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="备注" name="note">
                        <a-textarea v-model:value="form.note" placeholder="请输入备注" :rows="4" />
                    </a-form-item>
                </a-col> -->
                <a-col :span="24">
                    <a-form-item label="申请备注" name="applicationRemarks">
                        <a-textarea v-model:value="form.applicationRemarks" placeholder="请输入备注" :rows="4" />
                    </a-form-item>
                </a-col>
                <!-- <a-col :span="24">
                    <a-form-item label="备注" name="remark">
                        <a-textarea v-model:value="form.remark" placeholder="请输入备注" :rows="4" />
                    </a-form-item>
                </a-col> -->
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {financeLoan} from "@/api/finance";
import {financeDict} from "@/config/variableConfig";
// import DictSelect from "@/components/other/DictSelect";

export default {
    name: "AddOrEditModal",
    // components: {DictSelect},

    mixins: [formMixin],
    data() {
        return {
            financeDict,
            form: {
                id: null,
                companyCode: null,
                companyName: null,
                loanAmount: null,
                creditAmount: null,
                loanTime: null,
                creditTime: null,
                type: null,
                note: null,
                contact: null,
                contactNumber: null,
                applicationRemarks: null,
                creditType: null,
                remark: null,

            },
            rules: {
                    id: [],
                    companyCode: [],
                    loanAmount: [dataCheck.required({type:'number'})],
                    creditAmount: [dataCheck.required({type:'number'})],
                    loanTime: [dataCheck.required({})],
                    creditTime: [dataCheck.required({})],
                    type: [dataCheck.required({type:'number'})],
                    note: [],
                    contact: [dataCheck.required({})],
                    contactNumber: [dataCheck.required({})],
                    applicationRemarks: [],
                    creditType: [dataCheck.required({type:'number'})],
                    remark: []
            },

            options: [],

        }
    },

    computed: {
            submitUrl() {
                if (this.form.id) {
                    return financeLoan.edit
                } else {
                    return financeLoan.add
                }
            },
            postMethod() {
                if (this.form.id) {
                    return 'put'
                } else {
                    return 'post'
                }
            }
        },
    mounted() {
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>
